import { Link } from "react-router-dom";

import { Button } from "@pentabd/ui";

import { useLanguage } from "@hooks/useLanguage";
import { useTranslation } from "react-i18next";

interface ViewButtonType {
  link?: string;
  openInNewTab?: boolean;
  label?: string;
}

export const ViewButton = ({ link, openInNewTab, label }: ViewButtonType) => {
  const { language } = useLanguage();
  const { t } = useTranslation();

  const ViewBtn = () => (
    <Button fill="outline" type="light" size="xs">
      {label ? t(label) : language === "bn" ? "দেখুন" : "View"}
    </Button>
  );

  return (
    <div className="d-flex justify-content-center">
      {link ? (
        <Link to={link} target={openInNewTab ? "_blank" : "_self"}>
          <ViewBtn />
        </Link>
      ) : (
        <ViewBtn />
      )}
    </div>
  );
};
